import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { emptySortState, ISortState } from "../../../../models/common/ISortState";
import { IStatisticsOperatorIncidenceDetailed } from "../../../../models/statistics/IOperator";
import { sortArray } from "../../../../utils";


export interface IStatisticsOperatorIncidenceStateDetailed {
    operatorStatistics: IStatisticsOperatorIncidenceDetailed[];
    sort: ISortState;
    loading: boolean;
}

interface IInitialState {
    data: IStatisticsOperatorIncidenceStateDetailed;
}

export interface IStatisticsOperatorIncidenceStateDetailed {
    operatorStatistics: IStatisticsOperatorIncidenceDetailed[];
    sort: ISortState;
    loading: boolean;
}

const initialSateData = (): IStatisticsOperatorIncidenceStateDetailed => {
    return {
        loading: false,
        operatorStatistics: [],
        sort: emptySortState(),
    };
};

const initialState: IInitialState = {
    data: initialSateData(),
};

export const statiticsOperatorsIncidenceDetailedListSlice = createSlice({
    name: "statiticsOperatorsIncidenceDetailedListSlice",
    initialState,
    reducers: {
        resetStatisticsIncidenceOperatorDetailed: () => initialState,
        setListDetailed: (state, action: PayloadAction<IStatisticsOperatorIncidenceDetailed[]>) => {
            state.data.operatorStatistics = action.payload;
        },

        setStatisticsIncidenceOperatorDetailedLoading: (state, action: PayloadAction<boolean>) => {
            state.data.loading = action.payload;
        },
        setStatisticsIncidenceDetailedOperatorData: (state, action: PayloadAction<IStatisticsOperatorIncidenceStateDetailed>) => {
            console.log("setStatisticsIncidenceDetailedOperatorData", action.payload);
            state.data = action.payload  ;
            state.data.sort = {
                column: "",
                orderColumn: "",
            };
        },
        updateSortColumnDetailed: (state, action: PayloadAction<ISortState>) => {
            state.data.sort = action.payload;
            state.data.operatorStatistics = sortArray(state.data.operatorStatistics, state.data.sort);
        },
    },
});

export const { resetStatisticsIncidenceOperatorDetailed, setListDetailed, setStatisticsIncidenceOperatorDetailedLoading, setStatisticsIncidenceDetailedOperatorData, updateSortColumnDetailed } =
    statiticsOperatorsIncidenceDetailedListSlice.actions;

export default statiticsOperatorsIncidenceDetailedListSlice.reducer;
